export default class AbstractType {

}